import { createSelector } from 'reselect';

export const selectProductList = state => state.productList;

export const selectProductListConfig = createSelector(
  selectProductList,
  productList => productList.config,
);

export const selectProductListIsLoading = createSelector(
  selectProductList,
  productList => productList.isLoading,
);

export const selectProductListIsLoaded = createSelector(
  selectProductList,
  productList => productList.isLoaded,
);

export const selectProducts = createSelector(
  selectProductList,
  (productList) => {
    const { products } = productList;

    if (products.length) {
      const updatedProducts = products
        .filter(({ message }) => !(message && message.indexOf('not found') > -1))
        .map(product => {
          const { merchantRebates, showRebate, offers } = product;

          if (showRebate && offers.length) {
            const [firstOffer] = offers;
            const { merchant } = firstOffer;
            const hasTiers = merchant && merchant.tiers && merchant.tiers.length;

            product.merchantRebates = (hasTiers ? 'up to ' : '') + merchantRebates;
          }

          return product;
        });

      return updatedProducts.slice(0, 8);
    }

    return [];
  },
);
